var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { createReducer } from "typesafe-actions";
import { setSearchContext } from "./actions.js";
import { FEATURE_SEARCH_REDUCER_KEYS } from "./constants.js";
import { searchFeaturesEpicReducer, getExperimentationGroupsEpicReducer } from "./epics.js";
const defaultState = {
  items: getDefaultAsyncWrapperObj(),
  context: {},
  experimentationGroups: {}
};
const actionsReducer = createReducer(defaultState).handleAction(setSearchContext, (state, action) => {
  return __spreadProps(__spreadValues({}, state), {
    [FEATURE_SEARCH_REDUCER_KEYS.context]: action.payload
  });
});
const rootReducer = (state = defaultState, action) => {
  state = searchFeaturesEpicReducer.reduxChange(state, action);
  state = getExperimentationGroupsEpicReducer.reduxChange(state, action);
  state = actionsReducer(state, action);
  return state;
};
export {
  rootReducer as default,
  rootReducer
};
//# sourceMappingURL=reducers.js.map
